import { createContext } from 'react';
var LocaleContext = createContext(undefined);
export default LocaleContext;